module.exports = "/content/922c80532863d969a407bde69c5521ed.png";